import React, { FC, useCallback, useState } from 'react';
import { Button, Dialog, DialogActions, Grid, MenuItem } from '@material-ui/core';
import { Check, Close } from '@material-ui/icons';
import { PartnerPartnership } from 'src/models';
import { useCommonStyles } from 'src/styles';
import { CheckIcon, CustomDialogTitle, FieldLabel, MultiSelectControl } from 'src/components';
import { useStyles } from './styles';

export interface Props {
  open: boolean;
  translation: any;
  partnerships: PartnerPartnership[];
  onClose: () => void;
  applyFilter: (partnerships: string[]) => void;
  renderValueCustomCondition: (value: string[]) => void;
}

export const FiltersDialog: FC<Props> = ({ open, partnerships, translation, onClose, applyFilter, renderValueCustomCondition }) => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  const [selectedPartnerships, setSelectedPartnerships] = useState<string[]>(['All']);

  const applyNewFilter = () => {
    applyFilter(selectedPartnerships);
  };

  const clearFilter = () => {
    applyFilter(['All']);
  };

  const handleClose = () => {
    onClose();
  };

  const handlePartnershipSelectChange = useCallback(async (event) => {
    let options = event.target.value as string[];
    if (options.length === 0) {
      options = ['All'];
    }

    if (options.length > 1) {
      if (options.includes('All')) {
        if (options[options.length - 1] === 'All') {
          options = options.filter((option) => option === 'All');
        } else {
          options = options.filter((option) => option !== 'All');
        }
      }
    }

    setSelectedPartnerships(options);
  }, []);

  return (
    <Dialog onClose={handleClose} open={open} classes={{ paper: classes.dialog }}>
      <CustomDialogTitle title={translation.filters} onClose={() => onClose()} />
      <Grid container direction="column">
        {partnerships && partnerships.length !== 0 && (
          <Grid item>
            <FieldLabel label={translation.text_6447} />
            <MultiSelectControl renderValueCustomCondition={renderValueCustomCondition} value={selectedPartnerships} onChange={(event: any) => handlePartnershipSelectChange(event)}>
              <MenuItem className={selectedPartnerships.includes('All') ? classes.selectedOption : classes.option} value="All">
                <CheckIcon />
                <span>{translation.all}</span>
              </MenuItem>
              {partnerships.map((partnership) => (
                <MenuItem
                  className={selectedPartnerships.includes(partnership.partnershipCode as string) ? classes.selectedOption : classes.option}
                  key={partnership.partnershipCode}
                  value={partnership.partnershipCode ? partnership.partnershipCode : ''}
                >
                  <CheckIcon />
                  <span>{partnership.partnershipCode}</span>
                </MenuItem>
              ))}
            </MultiSelectControl>
          </Grid>
        )}
      </Grid>
      <DialogActions className={commonClasses.dialogAction}>
        <Button onClick={applyNewFilter} fullWidth startIcon={<Check />} className={commonClasses.activeDialogBtn}>
          {translation.text_65}
        </Button>
        <Button onClick={clearFilter} fullWidth startIcon={<Close />} className={commonClasses.cancelDialogBtn}>
          {translation.clearAll}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
